(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["ajax-cart-bubble"] && !Shopify.designMode) return;
  try {
    if (!window.inaBoxAjaxCartReady) {
    window.inaBoxAjaxCartReady = true;

    document.addEventListener('submit', async (event) => {
      const form = event.target.closest('[data-ajax-cart-form] form');
      if (!form) return;
      event.preventDefault();

      const ajaxContainer = form.closest('[data-ajax-cart-form]');
      const button = event.submitter || form.querySelector('[type="submit"]');
      const originalLabel = button?.textContent.trim();
      const singleAddon = ajaxContainer?.dataset.singleAddon === 'true';
      let addedSuccessfully = false;
      if (button) {
        button.disabled = true;
        button.textContent = ajaxContainer?.dataset.addingLabel || originalLabel;
      }

      try {
        const formData = new FormData(form);
        formData.delete('return_to');
        const addResponse = await fetch(`${window.Shopify.routes.root}cart/add.js`, {
          method: 'POST',
          headers: { Accept: 'application/json' },
          body: formData
        });
        const addedItem = await addResponse.json();
        if (!addResponse.ok) throw new Error(addedItem.description || 'Unable to add this item.');

        const cartResponse = await fetch(`${window.Shopify.routes.root}cart.js`, { headers: { Accept: 'application/json' } });
        const updatedCart = await cartResponse.json();
        document.querySelectorAll('[data-cart-count]').forEach((count) => {
          count.textContent = updatedCart.item_count;
          count.hidden = updatedCart.item_count < 1;
        });

        const bubble = document.querySelector('[data-cart-bubble]');
        if (bubble) {
          bubble.querySelector('[data-cart-bubble-product]').textContent = addedItem.product_title || addedItem.title || '';
          bubble.querySelector('[data-cart-bubble-count]').textContent = updatedCart.item_count;
          bubble.hidden = false;
        }

        addedSuccessfully = true;
        if (button) button.textContent = ajaxContainer?.dataset.addedLabel || originalLabel;
      } catch (error) {
        const bubble = document.querySelector('[data-cart-bubble]');
        window.alert(error.message || bubble?.dataset.errorLabel || 'Unable to add this item.');
      } finally {
        if (button) {
          if (addedSuccessfully && singleAddon) {
            button.disabled = true;
            button.textContent = ajaxContainer?.dataset.addedLabel || originalLabel;
          } else {
            button.disabled = false;
            window.setTimeout(() => { button.textContent = originalLabel; }, 1200);
          }
        }
      }
    });

    document.addEventListener('click', (event) => {
      const close = event.target.closest('[data-cart-bubble-close]');
      if (!close) return;
      const bubble = close.closest('[data-cart-bubble]');
      if (bubble) bubble.hidden = true;
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["inabox-product-card"] && !Shopify.designMode) return;
  try {
    if (!window.inaBoxCardGalleryReady) {
    window.inaBoxCardGalleryReady = true;
    const showCardImage = (gallery, requestedIndex) => {
      const slides = Array.from(gallery.querySelectorAll('[data-gallery-slide]'));
      if (slides.length < 2) return;
      const index = (requestedIndex + slides.length) % slides.length;
      slides.forEach((slide, slideIndex) => {
        const active = slideIndex === index;
        slide.classList.toggle('is-active', active);
        slide.setAttribute('aria-hidden', active ? 'false' : 'true');
      });
      gallery.dataset.galleryIndex = String(index);
      const counter = gallery.querySelector('[data-gallery-current]');
      if (counter) counter.textContent = String(index + 1);
    };
    document.addEventListener('click', (event) => {
      const arrow = event.target.closest('[data-gallery-previous], [data-gallery-next]');
      if (!arrow) return;
      event.preventDefault();
      event.stopPropagation();
      const gallery = arrow.closest('[data-card-gallery]');
      if (!gallery) return;
      const direction = arrow.hasAttribute('data-gallery-next') ? 1 : -1;
      showCardImage(gallery, Number(gallery.dataset.galleryIndex || 0) + direction);
    });
  }

  if (!window.inaBoxWishlistReady) {
    window.inaBoxWishlistReady = true;
    const wishlistKey = 'inabox-wishlist';
    const getWishlist = () => {
      try { return JSON.parse(localStorage.getItem(wishlistKey) || '[]'); } catch (error) { return []; }
    };
    const refreshButtons = () => {
      const handles = getWishlist().map((item) => item.handle);
      document.querySelectorAll('[data-wishlist-button]').forEach((button) => {
        button.classList.toggle('is-saved', handles.includes(button.dataset.handle));
        button.textContent = handles.includes(button.dataset.handle) ? 'Saved' : 'Save to wishlist';
      });
    };
    document.addEventListener('click', (event) => {
      const button = event.target.closest('[data-wishlist-button]');
      if (!button) return;
      const items = getWishlist();
      const index = items.findIndex((item) => item.handle === button.dataset.handle);
      if (index >= 0) {
        items.splice(index, 1);
      } else {
        items.push({ handle: button.dataset.handle, title: button.dataset.title, url: button.dataset.url, image: button.dataset.image, price: button.dataset.price });
      }
      localStorage.setItem(wishlistKey, JSON.stringify(items));
      refreshButtons();
    });
    document.addEventListener('DOMContentLoaded', refreshButtons);
  }
  } catch(e) { console.error(e); }
})();

})();
